import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { ProductType } from '@/data/types/Product';
import { useProductDetailsPrice } from '@/components/blocks/ProductDetails/Price';

export const OutfitItemPrice: FC<{ product: ProductType }> = ({ product }) => {
	const { price, priceWithoutOffer, additionalOffer, offer, list, currency } =
		useProductDetailsPrice(product, product);

	return (
		<Stack direction="column">
			{(offer > 0 && offer < list) || additionalOffer ? (
				<Typography
					component="span"
					sx={{
						color: '#1C1C1C',
						fontSize: '14px',
						letterSpacing: '0px',
						fontWeight: 'normal',
						textDecoration: 'line-through',
					}}
					data-testid="list-price"
					id="list-price"
				>
					<PriceDisplay currency={currency} min={priceWithoutOffer} />
				</Typography>
			) : null}

			{offer > 0 && offer === list && !additionalOffer ? (
				<Typography
					component="span"
					data-testid="offer-price"
					id="offer-price"
					sx={{
						fontSize: '14px',
						letterSpacing: '0px',
						color: '#2C2C2C',
						fontWeight: 'bold',
					}}
				>
					<PriceDisplay currency={currency} min={price} />
				</Typography>
			) : (offer > 0 && offer < list) || additionalOffer ? (
				<Typography
					component="span"
					data-testid="offer-price"
					id="offer-price"
					sx={{
						fontSize: '14px',
						letterSpacing: '0px',
						color: '#B40309',
						fontWeight: 'bold',
					}}
				>
					<PriceDisplay currency={currency} min={price} />
				</Typography>
			) : null}

			{offer === 0 ? (
				<Typography variant="h5" component="span" data-testid="no-price" id="no-price">
					{'N/A'}
				</Typography>
			) : null}
		</Stack>
	);
};
